import { ReactNode, useEffect, useRef, useState } from 'react'

import { IconButton } from '@tribeplatform/react-ui-kit/Button'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'
import { Input } from '@tribeplatform/react-ui-kit/Input'

interface EventListHeaderProps {
  title: ReactNode
  onSearch?: (query: string) => void
  searchPlaceholder?: string
}

export const EventListHeader = ({
  title,
  onSearch,
  searchPlaceholder,
}: EventListHeaderProps) => {
  const [isSearchOpen, setIsSearchOpen] = useState(false)
  const [searchQuery, setSearchQuery] = useState('')
  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (isSearchOpen && inputRef.current) {
      inputRef.current.focus()
    }
  }, [isSearchOpen])

  const handleSearchClose = () => {
    setIsSearchOpen(false)
    setSearchQuery('')
    onSearch?.('')
  }

  return (
    <div className="text-lg flex items-center justify-between h-10">
      {!isSearchOpen && (
        <div className="flex items-center animate-in fade-in duration-200 w-full">
          <span className="text-content mr-2">{title}</span>
          {onSearch && (
            <IconButton
              className="ml-auto text-content-subdued hover:text-content"
              icon={<SvgIcon name="search" />}
              onClick={() => setIsSearchOpen(true)}
              variant="secondaryNeutral"
              size="md"
            />
          )}
        </div>
      )}

      {isSearchOpen && (
        <div className="flex items-center flex-1 animate-in fade-in slide-in-from-right-2 duration-200">
          <Input
            ref={inputRef}
            value={searchQuery}
            onChange={e => {
              setSearchQuery(e.target.value)
              onSearch?.(e.target.value)
            }}
            placeholder={searchPlaceholder}
            className="flex-1"
            size="compact"
            trailingAddon={
              <IconButton
                icon={<SvgIcon name="close" />}
                onClick={handleSearchClose}
                variant="plainNeutral"
                size="sm"
                rounded
              />
            }
          />
        </div>
      )}
    </div>
  )
}
